import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import ConceptosGastosEmbarquesCreate from "./ConceptosGastosEmbarquesCreate";
import axios from "axios";
import {
  ButtonGroup,
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
} from "reactstrap";
import Header from "../../../layout/Header/Header";
import Footer from "../../../layout/Footer/Footer";

import Swal from "sweetalert2";
import Baja from "../../Baja";

function ListadoConceptosGastosEmbarques() {
  const { user } = useContext(AuthContext);
  const URL_CONCEPTOS_GASTOS_EMBARQUES = import.meta.env.VITE_URL_CONCEPTOS_GASTOS_EMBARQUES;
  const URL_LOGS = import.meta.env.VITE_URL_LOGS;
  const [conceptosGastos, setConceptosGastos] = useState([]);
  const [modal, setModal] = useState(false);
  const [concepto, setConcepto] = useState("");
  const [fijo, setFijo] = useState("");
  const [estimado, setEstimado] = useState(0);
  const toggle = () => setModal(!modal);
  const [text, setText] = useState(false);

  const [idEdit, setIdEdit] = useState()

  useEffect(() => {
    axios
      .get(URL_CONCEPTOS_GASTOS_EMBARQUES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allConceptosGastos = response.data;
        setConceptosGastos(allConceptosGastos);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  function editConceptosGastos(event) {
    event.preventDefault();
    const URL_CONCEPTOS_GASTOS_EMBARQUES_EDIT = `${import.meta.env.VITE_URL_CONCEPTOS_GASTOS_EMBARQUES}/${idEdit}`;
    axios
      .patch(
        URL_CONCEPTOS_GASTOS_EMBARQUES_EDIT,
        {
          concepto,
          estimado,
          fijo
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        axios
        .post(
          URL_LOGS,
          {
            tipo:'Editar Conceptos Gastos',
            detalle: concepto,
            user: user.id
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        toggle();
        Swal.fire("Good job!", "Actualizado con exito", "success");
        window.location.reload();
      })
       .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
        });
        console.log(error);
      });
  }

  function jalaInfo(idEdit, concepto, estimado, fijo) {
        setConcepto(concepto);
        setEstimado(estimado);
        setFijo(fijo);
        setIdEdit(idEdit);
        toggle();
  }

  return (
    <>
      <Header />
      <br />
      <br />
      <div className="container">
        { user.menu_compras ? (
          <div className="row">
            {
              <div className="col-md-6 col-sm-6">
                <div className="card">
                  <div className="card-body">
                    <h3 align="center">Conceptos</h3>
                    <Table
                      size="sm"
                      striped
                      borderless
                      className="table-responsive-xl"
                    >
                      <thead>
                        <tr>
                          <th className="tituloTabla">Concepto</th>
                          <th className="tituloTabla">Estimado</th>
                          <th className="tituloTabla">Fijo</th>
                          <th className="tituloTabla">Editar</th>
                        </tr>
                      </thead>
                      <tbody>
                        {conceptosGastos
                          .sort((a, b) => (a.concepto > b.concepto ? 1 : -1))
                          .map((a) => {
                              return (
                                <tr>
                                  <td>{a.concepto}</td>
                                  <td>{a.estimado}</td>
                                  <td>{a.fijo}</td>
                                  <td>
                                    
                                    <Button
                                      color="info"
                                      id="Editar"
                                      size="sm"
                                      onClick={(e) => jalaInfo(a._id, a.concepto, a.estimado, a.fijo)}
                                    >
                                      <i className="far fa-edit"></i>{" "}
                                    </Button>                                
                                   
                                  </td>
                                </tr>
                              );
                          })}
                      </tbody>
                    </Table>
                  </div>
                </div>
              </div>
            }
            <div className="col-md-6 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <ConceptosGastosEmbarquesCreate />
                </div>
              </div>
            </div>
          </div>
        ) : undefined}
      </div>
      <Modal size="sm" isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Editar Concepto</ModalHeader>
        <ModalBody>
          <Label className="mr-sm-2">Concepto</Label>
          <Input
            className="col-sm-12"
            type="text"
            value={concepto}
            required
            onChange={(e) => {
              setConcepto(e.target.value);
            }}
          />
           <Label className="mr-sm-2">Estimado</Label>
          <Input
            className="col-sm-12"
            type="text"
            value={estimado}
            required
            onChange={(e) => {
              setEstimado(e.target.value);
            }}
          />
            <Label>Fijo</Label>
                <Input
                    type="select"
                    placeholder="Fijo"
                    value={fijo}
                    required
                    onChange={(e) => {
                      setFijo(e.target.value);
                    }}
                  >
                    <option value="Si">Si</option>
                    <option value="No">No</option>
                  </Input>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editConceptosGastos}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ListadoConceptosGastosEmbarques;
